import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export type CommandGroupProps = ComponentProps<typeof CommandPrimitive.Group>;

const Group = ({ ref, className, ...props }: CommandGroupProps) => (
  <CommandPrimitive.Group
    ref={ref}
    className={cn(
      "overflow-hidden p-1 text-neutral-10 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-50",
      className
    )}
    {...props}
  />
);

Group.displayName = CommandPrimitive.Group.displayName;

export default Group;
